import React from "react";
import PropTypes from "prop-types";
import EmailQualityDashboard from "components/screens/email-quality-dashboard";

// Per-company Email Insights tab (S3DEV2-7412). Reuses the standalone Email Quality Dashboard with the
// company pinned via `lockedCompanyGuid` (Company filter hidden) and rendered without its page-level header.
const CompanyEmailInsights = ({ params }) => (
  <EmailQualityDashboard lockedCompanyGuid={params.id} embedded />
);

CompanyEmailInsights.propTypes = {
  params: PropTypes.shape({ id: PropTypes.string })
};

export default CompanyEmailInsights;
